/**
 * @desc 查询受益部门列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.RevenueDepartmentResponseDto>>;
export function request(body: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/revenueDepartment/getListRpc`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
